<template>
  <div>
    <Tabs :tabIndex="tabIndex"/>
    <div class="detail-employee container">
      <b-row>
        <b-col cols="12" lg="3" class="mypage__sidebar">
          <Sidebar />
        </b-col>
        <b-col cols="12" lg="9" class="pl-70">
          <div class="body-table dashboard scroll-bar list-files-table list-files-table-favorite">
            <table class="table table-csUser table-csHistory table-mb-pd">
              <thead>
              <tr>
                <th scope="col">名前</th>
                <th scope="col" class="text-center wi-25">観覧回数</th>
                <th scope="col" class="hidden-mb w-20 text-center">最終観覧日</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="listHistoryLog in listHistoryLogs" :key="listHistoryLog.object_id">
                  <th scope="row" class="table-name">
                    <div class="tableInfo--box table-name">
                      <div class="table-name--box">
                        <div class="text-center avt-favorite">
                          <img :src="listHistoryLog.icon_url" alt class="img-preview avt-folder" />
                          <div class="mypage__kindFile mypage__kindFile-list kindFile-mb">
                            <div class="mypage__iconList" v-if="isVideoAndImage(listHistoryLog.media_type_id)">
                              <img src="@img/icon/icon-image.svg" alt="" v-if="isImage(listHistoryLog.media_type_id)">
                              <img src="@img/icon/icon-video.svg" alt="" v-if="isVideo(listHistoryLog.media_type_id)">
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="admin-name flex-wrap name-width ml-0">
                        <div class="name w-100 d-none d-lg-block">{{truncate(listHistoryLog.name,15,'...')}}</div>
                        <div class="name w-100 d-block d-lg-none">{{truncate(listHistoryLog.name,12,'...')}}</div>
                        <div class="date">{{formatDate(listHistoryLog.created_at)}}</div>
                      </div>
                    </div>
                  </th>
                  <td class="table-department text-center w-20">
                    {{formatNumber(listHistoryLog.total)}}回
                  </td>
                  <td class="table-role hidden-mb w-20 text-center">{{formatDate(listHistoryLog.last_date)}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tabs from '../../../../components/Admin/Company/Tabs'
import Breadcrumb from '@/components/share/Breadcrumb'
import Sidebar from '@/components/Admin/Company/Employee/SidebarDetail'
import moment from 'moment'
import {mapState} from 'vuex'
import {MEDIA_TYPE} from '../../../../utils/constant'
export default {
  name: 'DetailEmployee',
  components: {
    Breadcrumb,
    Sidebar,
    Tabs
  },
  data () {
    return {
      tabIndex: 4
    }
  },
  methods: {
    formatDate (date) {
      return moment(date).format('YYYY/MM/DD')
    },
    isImage (value) {
      return value === MEDIA_TYPE.IMAGE_ROLE_ID
    },
    isVideo (value) {
      return value === MEDIA_TYPE.VIDEO_ROLE_ID
    },
    isVideoAndImage (mediaTypeId) {
      return mediaTypeId === MEDIA_TYPE.IMAGE_ROLE_ID || mediaTypeId === MEDIA_TYPE.VIDEO_ROLE_ID
    }
  },
  mounted () {
    this.$store.dispatch('adminEmployee/detailEmployee', {id: this.$route.params.employee_id})
    this.$store.dispatch('adminEmployee/getListLogs', {employee_id: this.$route.params.employee_id, company_id: this.$route.params.id})
    window.scrollTo({
      top: 0
    })
  },
  computed: {
    ...mapState({
      detailEmployee: state => state.adminEmployee.detailEmployee,
      listHistoryLogs: state => state.adminEmployee.listHistoryLogs
    })
  }
}
</script>

<style scoped lang="scss">
@import "@/assets/stylesheet/auth/historyview.scss";
@import '@/assets/stylesheet/user/list_user.scss';
@import '@/assets/stylesheet/admin/vendor.scss';
@import '@/assets/stylesheet/auth/dashboard.scss';
@import "@/assets/stylesheet/auth/listfile.scss";
@import "@/assets/stylesheet/mypage/detail_mypage.scss";
  .dashboard {
    @media screen and (max-width: 991px) {
      margin-top: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Admin/Company/Employee/Detail.vue